import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { DeleteRivenditoreModalComponent } from './delete-rivenditore-modal';

export const DeleteRivenditoreModalModule: string = ng
    .module('archiSmall.components.deleteRivenditoreModalModule', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('deleteRivenditoreModalComponent', DeleteRivenditoreModalComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/components/delete-rivenditore-modal/delete-rivenditore-modal.module.ts